export enum ToothEruption {
	PENDING = 'PENDING',
	ERUPTED = 'ERUPTED',
}
